import { filter, merge, Observable, scan, Subject } from "rxjs";
import { computed } from "../decorators/computed";
import { PlatformEvent } from "./platform-event";

export type LiveInteraction = {
  action: string;
  entityId: string;
  entityType: string;
};

export class Live {
  constructor(
    private readonly wss$: Subject<PlatformEvent>,
    private readonly inputWss$: Subject<
      Omit<PlatformEvent, "committedAt" | "committedBy">
    >
  ) {}

  public send(event: Omit<PlatformEvent, "committedAt" | "committedBy">) {
    this.inputWss$.next(event);
  }

  private hidePlatformEvent$ = new Subject<number>();

  public hidePlatformEvent(index: number) {
    this.hidePlatformEvent$.next(index);
  }

  @computed
  get platformEvents$(): Observable<(PlatformEvent & { hidden: boolean })[]> {
    return merge(this.wss$, this.hidePlatformEvent$).pipe(
      scan((acc, event) => {
        if (typeof event === "number") {
          (acc[event] as PlatformEvent & { hidden: boolean }).hidden = true;
          return [...acc];
        }

        return [...acc, { ...event, hidden: false }];
      }, [] as (PlatformEvent & { hidden: boolean })[])
    );
  }

  chat$(entityId: string, entityType: string) {
    return this.wss$.pipe(
      filter((event) => {
        return event.entityId === entityId && event.entityType === entityType;
      })
    );
  }
}
